import { useEffect } from "react";

/** A sheet-style dialog from the bottom of the screen; closes on Escape, the × or a tap on the backdrop. */
const Popup = ({ onClose, title, children }) => {
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  const onBackdropClick = (event) => {
    if (event.target === event.currentTarget) onClose();
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className="dialog-backdrop" onClick={onBackdropClick}>
      <div className="dialog" role="dialog" aria-modal="true" aria-label={title || undefined}>
        <div className="dialog-head">
          {title ? <h2 className="dialog-title">{title}</h2> : <span />}
          <button type="button" className="btn btn-round btn-xs btn-outline" aria-label="Close" onClick={onClose}>
            ×
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Popup;
